import { render, staticRenderFns } from "./Clientes.vue?vue&type=template&id=68dfe3a8&scoped=true"
import script from "./Clientes.vue?vue&type=script&lang=js"
export * from "./Clientes.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "pretty-checkbox/dist/pretty-checkbox.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./Clientes.vue?vue&type=style&index=2&id=68dfe3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dfe3a8",
  null
  
)

export default component.exports